// extracted by extract-css-chunks-webpack-plugin
module.exports = {"reviewSlider":"css-36N4A09Ggv","review":"css-SRjJAwJZq7","review_content":"css-ASo84KJuBx","review_content_text":"css-PtL1O8VaUg","review_reviewer":"css-4Gi9VJwLgU"};